var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplyCamera({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#fff",
    width: 12.916,
    height: 10.333,
    viewBox: "0 0 12.916 10.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.958,350.075a1.937,1.937,0,1,0,1.937,1.937A1.937,1.937,0,0,0,32.958,350.075Zm5.166-1.937h-1.55a.575.575,0,0,1-.51-.368l-.4-1.2a.576.576,0,0,0-.51-.367H30.762a.575.575,0,0,0-.51.368l-.4,1.2a.576.576,0,0,1-.51.367h-1.55a1.3,1.3,0,0,0-1.292,1.292v5.812a1.3,1.3,0,0,0,1.292,1.292H38.124a1.3,1.3,0,0,0,1.292-1.292v-5.812A1.3,1.3,0,0,0,38.124,348.137Zm-5.166,7.1a3.229,3.229,0,1,1,3.229-3.229A3.229,3.229,0,0,1,32.958,355.241Zm4.714-4.909a.452.452,0,1,1,.452-.452A.452.452,0,0,1,37.672,350.332Z",
    transform: "translate(-26.5 -346.2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplyCamera);
export default __webpack_public_path__ + "static/media/reply-camera.8799006752df12bfe1d96d735883e5c2.svg";
export { ForwardRef as ReactComponent };